module.exports = __webpack_public_path__ + "img/rejschedicon.a3471218.svg";